module.exports = __webpack_public_path__ + "img/gimnasio.bcaeed9a.svg";